var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.fileType === "pdf"
    ? _c("img", {
        staticClass: "icon-item",
        attrs: { src: require("@/assets/images/file/pdf.png") },
      })
    : _vm.fileType === "mp3"
    ? _c("img", {
        staticClass: "icon-item",
        attrs: { src: require("@/assets/images/file/mp3.png") },
      })
    : _vm.fileType === "mp4"
    ? _c("img", {
        staticClass: "icon-item",
        attrs: { src: require("@/assets/images/file/mp4.png") },
      })
    : _vm.fileType === "txt"
    ? _c("img", {
        staticClass: "icon-item",
        attrs: { src: require("@/assets/images/file/txt.png") },
      })
    : _vm.fileType === "zip"
    ? _c("img", {
        staticClass: "icon-item",
        attrs: { src: require("@/assets/images/file/zip.png") },
      })
    : _vm.isImage
    ? _c("img", {
        staticClass: "icon-item",
        attrs: { src: require("@/assets/images/file/image.png") },
      })
    : _vm.isVideo
    ? _c("img", {
        staticClass: "icon-item",
        attrs: { src: require("@/assets/images/file/video.png") },
      })
    : _vm.isWord
    ? _c("img", {
        staticClass: "icon-item",
        attrs: { src: require("@/assets/images/file/word.png") },
      })
    : _vm.isExcel
    ? _c("img", {
        staticClass: "icon-item",
        attrs: { src: require("@/assets/images/file/excel.png") },
      })
    : _vm.isPPT
    ? _c("img", {
        staticClass: "icon-item",
        attrs: { src: require("@/assets/images/file/ppt.png") },
      })
    : _vm.isWPSWord
    ? _c("img", {
        staticClass: "icon-item",
        attrs: { src: require("@/assets/images/file/wps-doc.png") },
      })
    : _vm.isWPSExcel
    ? _c("img", {
        staticClass: "icon-item",
        attrs: { src: require("@/assets/images/file/wps-excel.png") },
      })
    : _c("img", {
        staticClass: "icon-item",
        attrs: { src: require("@/assets/images/file/other.png") },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }